import { type InsuranceCorporateIdentity } from "../types";

export function BkkDiakonieLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.4 258.6C159.4 275.2 158.7 278.8 153.2 278.8H148.8V236.9H152.8C159.1 236.9 159.4 242.8 159.4 256.2V258.6ZM165.2 258.6V256.2C165.2 240.7 164.7 232.2 152.8 232.2H143.3V283.4H153.4C164.9 283.4 165.2 274.5 165.2 258.6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.4 229.8H181.6V224H177.4V229.8ZM186.6 229.8H190.7V224H186.6V229.8ZM194 272.6V235.1H188.8V272.5C188.8 276.8 188.2 280.1 184.1 280.1C180 280.1 179.4 276.8 179.4 272.5V235.1H174.2V272.5C174.2 279.4 176.4 284.1 184.2 284.1C191.8 284.2 194 279.2 194 272.6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.4 247.5C218.4 253.6 217.2 256.9 212.8 256.9H208.7V239.3H212.9C217.3 239.3 218.4 241.9 218.4 247.5ZM224.1 283.4C223.5 281.1 223.3 277.6 223.3 275.7C223.3 275.7 223.2 268.9 223.2 267.2C223.2 260.9 220.7 259.7 217 259C221.3 257.9 223.7 255.6 223.7 247.6C223.7 239 221 235.2 213.8 235.2H203.6V283.5H208.8V261.1H212.7C216.5 261.1 218 262.6 218.1 267.7L218.2 276.1C218.2 278.3 218.3 281.6 219 283.3H224.1V283.4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M233.3 283.4H238.5V235.1H233.3V283.4ZM255.7 283.4L243.9 257.6L254.5 235.1H248.9L238.7 257.6L249.8 283.4H255.7Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277 258.9C277 272.9 277 280.2 271.5 280.2C266.1 280.2 266 273.8 266 258.9C266 246.4 266 238.3 271.5 238.3C276.9 238.3 277 245.6 277 258.9ZM282.4 258.9C282.4 243.8 282.6 234.3 271.6 234.3C260.7 234.3 260.6 245 260.6 258.9C260.6 275.3 260.6 284.2 271.5 284.2C282.4 284.2 282.4 275.2 282.4 258.9Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.5 248.9C306.5 255 305.5 257.6 301.1 257.6H296.5V239.4H301C305.2 239.4 306.5 241.9 306.5 248.9ZM311.8 248.9C311.8 239.2 309.3 235.1 301.6 235.1H291.2V283.4H296.4V261.9H301.5C309.7 261.9 311.8 258.5 311.8 248.9Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M333.4 248.9C333.4 255 332.4 257.6 328 257.6H323.4V239.4H327.9C332.1 239.4 333.4 241.9 333.4 248.9ZM338.7 248.9C338.7 239.2 336.2 235.1 328.5 235.1H318.1V283.4H323.3V261.9H328.4C336.6 261.9 338.7 258.5 338.7 248.9Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M369.5 265.5H359.9L364.6 238.5L369.5 265.5ZM378.4 283.4L368.1 232.2H361.5L351 283.4H356.5L358.9 270.2H370.2L372.6 283.4H378.4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M400.1 260C400.1 275.6 399.5 279 394.3 279H390V239.5H393.8C399.8 239.5 400 245.1 400 257.7V260M405.5 260V257.7C405.5 243.1 405 235.1 393.8 235.1H384.8V283.4H394.3C405.2 283.4 405.5 275 405.5 260Z"
        fill="white"
      />
      <path
        d="M428.9 283.4V279.1H418.1V235.1H412.9V283.4H428.9Z"
        fill="white"
      />
      <path
        d="M452.1 283.4V279.1H440.6V260.5H451V256.3H440.6V239.4H451.7V235.1H435.3V283.4H452.1Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M473.8 247.5C473.8 253.6 472.6 256.9 468.2 256.9H464.1V239.3H468.3C472.7 239.3 473.8 241.9 473.8 247.5ZM479.5 283.4C478.9 281.1 478.7 277.6 478.7 275.7C478.7 275.7 478.6 268.9 478.6 267.2C478.6 260.9 476.1 259.7 472.4 259C476.7 257.9 479.1 255.6 479.1 247.6C479.1 239 476.4 235.2 469.2 235.2H459V283.5H464.2V261.1H468.1C471.9 261.1 473.4 262.6 473.5 267.7L473.6 276.1C473.6 278.3 473.7 281.6 474.4 283.3H479.5V283.4Z"
        fill="white"
      />
      <path d="M139.5 285H112.1V289.4H139.5V285Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.2 269.1C47.2 275.7 46.4 280.1 41.6 280.1H36.8V259.1H40.9C46.7 259.1 47.2 262.3 47.2 269.1ZM46.9 246.4C46.9 252.8 46.1 256.1 41 256.1H36.8V237.2H41.4C46.4 237.2 46.9 241.6 46.9 246.4ZM51.1 269.2C51.1 262.2 50.3 258.8 45 257.5C50.4 256.4 50.6 251.3 50.6 245.8C50.6 238.9 49.1 234.2 41.9 234.2H33V283.1H42.1C49.7 283.1 51.1 278 51.1 269.2Z"
        fill="#003869"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.2 283.1H64V234.2H60.2V283.1ZM80 283.1L68 256.8L78.4 234.2H74.4L64.3 256.8L75.8 283.1H80Z"
        fill="#003869"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.8 283.1H90.6V234.2H86.8V283.1ZM106.5 283.1L94.5 256.8L105 234.2H101L90.8 256.8L102.3 283.1H106.5Z"
        fill="#003869"
      />
    </svg>
  );
}

export const BkkDiakonie: InsuranceCorporateIdentity = {
  id: "bkk-diakonie",
  name: "BKK Diakonie",
  logo: BkkDiakonieLogo,
  backgroundColor: "#93C01F",
  textColor: "#FFFFFF",
  wildcard: "diakonie",
  type: "statutory",
};
